import { render, staticRenderFns } from "./MetadataLayout.vue?vue&type=template&id=d8f04dec"
import script from "./MetadataLayout.vue?vue&type=script&lang=js"
export * from "./MetadataLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports